export const TOP_REMOVAL_REASON = [
  "off_topic",
  "trolling",
  "misinformation",
];
export const REMOVAL_REASONS = [
  "copyright_infringement",
  "defamatory",
  "discredited_research",
  "discriminatory",
  "fake_name",
  "offensive",
  "other",
  "personal_abuse",
  "spam",
  "threatening",
];
